import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HttpClientModule} from '@angular/common/http';
import {BaseService} from './service/BaseService';
import {LoginService} from './service/LoginService';
import {SealService} from './service/SealService';
import {SignupService} from './service/SignupService';
import {ExporterService} from './service/ExporterService';
import {PoService} from './service/PurchaseOrderService'
import {ImportPurchaseOrderService} from './service/ImportPurchaseOrderService'
import {DataService} from './service/DatapassService';
import {PassService} from './service/PassService';
import {MasterHelper} from './service/MasterHelper';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DataTableModule} from "angular2-datatable";
import {routing} from './app.routing';
import {routing1} from './app.routing';
import {PopupModule} from 'ng2-opd-popup';
import {Ng4LoadingSpinnerModule} from 'ng4-loading-spinner';
import {PasswordStrengthBarModule} from 'ng2-password-strength-bar';
import {PasswordStrengthBar} from './components/signup/strengthbar'
import {AppCustomPreloader} from './AppCustomPreloader';
import {AppComponent} from './app.component';
import {IndexComponent} from './components/index/index.component';
import {SignupComponent} from './components/signup/signup.component';
import {LoginComponent} from './components/login/login.component';
import {DatePipe} from "@angular/common";
//import {HomeComponent} from './components/home/home.component';
//import {ViewDetailComponent} from './components/view-detail/view-detail.component';
//import {CreatesealComponent} from './components/createseal/createseal.component';
//import {ExporterMaster} from './components/exporter_master/exporter_master';
//import {ExporterListComponent} from './components/exporter-list/exporter-list.component';
//import {ViewPoComponent} from './components/view-po/view-po.component';
//import {CreatePoComponent} from './components/create-po/create-po.component';
//import {UppercaseDirective} from './UppercaseDirective';
import {UpperCaseModule} from './components/lazyloader/UpperCaseModule';
import {CopyPasteModule} from './components/lazyloader/CopyPasteModule';
//import {ImportPurchaseOrderDetailComponent} from './components/import-purchase-order-detail/import-purchase-order-detail.component';
//import {ImportPurchaseOrderListingComponent} from './components/import-purchase-order-listing/import-purchase-order-listing.component'
import {MatSelectModule} from '@angular/material'
import {MatIconModule, MatTooltipModule, MatButtonModule,MatTabsModule} from '@angular/material'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {A2Edatetimepicker} from 'ng2-eonasdan-datetimepicker';
import {TabService} from './components/Multitab/tab.service'
import { TabContentComponent } from "./components/Multitab/tab-content.component";
import { ContentContainerDirective } from "./content-container.directive";
import {importHelper} from "./components/Multitab/importHelper";
import { HeaderComponent } from './components/header/header.component';
import {MasterVO} from './model/MasterVO';

@NgModule({
    exports: [
        MatSelectModule,
    ],
    imports: [BrowserModule, MatSelectModule, BrowserAnimationsModule, PasswordStrengthBarModule, HttpClientModule, FormsModule, DataTableModule, Ng4LoadingSpinnerModule.forRoot(), routing, routing1,ReactiveFormsModule, PopupModule.forRoot(),A2Edatetimepicker,UpperCaseModule,CopyPasteModule,MatTabsModule,MatIconModule,MatButtonModule],
    declarations: [AppComponent, LoginComponent, IndexComponent, SignupComponent,
        PasswordStrengthBar,TabContentComponent,ContentContainerDirective, HeaderComponent,],
    bootstrap: [AppComponent],
    providers: [BaseService, LoginService, SealService, DataService, PassService, SignupService,MasterHelper, ExporterService, PoService, ImportPurchaseOrderService,AppCustomPreloader,DatePipe,TabService,importHelper,MasterVO]
})
export class AppModule {}



// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/app.module.ts